export default function ClickTabModel(type: string) {
    return {
        type,
    }
}